import { z } from 'zod';
/**
 * Contrats du JOURNAL DES APPELS AU LLM DE VISION (tagging IA) — source unique front + back.
 *
 * Chaque appel du job `ai_tag` à un modèle de vision est tracé : le PROMPT envoyé
 * (taxonomie + descriptions incluses), la RÉPONSE brute du modèle, et la ventilation
 * liés / hors taxonomie. Permet à l'utilisateur de VÉRIFIER ce qui part (les tags existants
 * et l'interdiction de créer de nouvelles étiquettes) et ce qui revient.
 *
 * ⚠ La clé d'API n'apparaît JAMAIS ici (elle voyage en en-tête, jamais dans le prompt).
 */
/**
 * Une trace d'appel : le PROMPT envoyé + la RÉPONSE brute + la ventilation. `assetId`/
 * `relPath` identifient la photo (nullable par robustesse). `linkedCount` = nb de tags
 * EXISTANTS proposés ; `newLabelCount` = nb de labels renvoyés par le modèle mais HORS
 * taxonomie → IGNORÉS (monde fermé, Lot 2 ; jamais stockés ni proposés à une revue).
 * `reachable` faux + `error` = le fournisseur n'a pas répondu.
 */
export const aiTagTraceSchema = z.object({
    id: z.uuid(),
    createdAt: z.string().datetime({ offset: true }),
    jobId: z.uuid().nullable(),
    assetId: z.uuid().nullable(),
    relPath: z.string().nullable(),
    model: z.string(),
    prompt: z.string(),
    response: z.string().nullable(),
    reachable: z.boolean(),
    linkedCount: z.number().int().nonnegative(),
    newLabelCount: z.number().int().nonnegative(),
    error: z.string().nullable(),
});
/** Bornes de pagination du journal (query `limit`/`offset`). */
export const AI_TAG_TRACES_LIMIT_MAX = 50;
export const AI_TAG_TRACES_LIMIT_DEFAULT = 20;
/** Query de `GET /api/libraries/:id/ai-tag/traces` : pagination bornée. */
export const aiTagTracesQuerySchema = z.object({
    limit: z.coerce
        .number()
        .int()
        .min(1)
        .max(AI_TAG_TRACES_LIMIT_MAX)
        .optional()
        .default(AI_TAG_TRACES_LIMIT_DEFAULT),
    offset: z.coerce.number().int().nonnegative().optional().default(0),
});
/** Page de traces + total (badge/pagination). */
export const aiTagTracesResultSchema = z.object({
    traces: z.array(aiTagTraceSchema),
    total: z.number().int().nonnegative(),
});
//# sourceMappingURL=ai-trace.js.map